"use strict";

var cov_6ld0gk89d = function () {
  var path = "/Volumes/Github-Projects/gitea-react-toolkit/src/components/file/index.js";
  var hash = "ede0261200e2479562714ba6880ac8c421033076";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/Volumes/Github-Projects/gitea-react-toolkit/src/components/file/index.js",
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "ede0261200e2479562714ba6880ac8c421033076"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  FileCard: true,
  FileForm: true,
  useFile: true
};
Object.defineProperty(exports, "FileCard", {
  enumerable: true,
  get: function get() {
    return _FileCard.default;
  }
});
Object.defineProperty(exports, "FileForm", {
  enumerable: true,
  get: function get() {
    return _FileForm.default;
  }
});
Object.defineProperty(exports, "useFile", {
  enumerable: true,
  get: function get() {
    return _useFile.default;
  }
});

var _FileCard = _interopRequireDefault(require("./FileCard"));

var _FileForm = _interopRequireDefault(require("./FileForm"));

var _useFile = _interopRequireDefault(require("./useFile"));

var _File = require("./File.context");

Object.keys(_File).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _File[key];
    }
  });
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}